import { useState } from "react";
import Head from "next/head";
import withSession from "../lib/session";
import { Layout } from "../common/Layout";
import { Container, Grid, Button } from "@mui/material";
import { gql, request } from "graphql-request";

import { BikeReserve } from "../common/BikeReserve";

export default function BookBiking() {
  if (typeof window === "undefined") {
    // breaks the initial rendering of the sx prop for the MainType box...not entirely sure why
    return null;
  }

  return (
    <Layout>
      <Container>
        <BikeReserve />
      </Container>
    </Layout>
  );
}

// export const getServerSideProps = withSession(async function ({ req, res }) {
//   const user = req.session.get("user") || null;

//   return {
//     props: { user },
//   };
// });
